/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAbacus} from '@fortawesome/pro-duotone-svg-icons';

const BulkOperationsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faAbacus} {...props} />
);

export default BulkOperationsIcon;
